import React from 'react'
import Code from './blogPostComponents/Code';
import { useMediaQuery } from '@material-ui/core';
import ContentSection from './ContentSection';


const AboutSection = ( {className, style, maxHeight} ) => {

  const isMobile = useMediaQuery('(max-width: 460px)');
  // const isTablet = useMediaQuery('(max-width: 768px)');

  let text = ( textDict ) => {
    if (isMobile){ return textDict.mobile };
    // if (isTablet){ return textDict.tablet };
    return textDict.default;
  } 

  const traitsOfCharacter = {
    default: "# I am ambitious and I love new challenges",
    mobile: `# I am ambitious
  # and I love new challenges`
  };

  const skills = {
    default: `'Python', 'PyTorch', 'Django', 'JS/HTML/CSS', 'React',
      'Tailwind CSS', 'C++', 'CMAKE', 'ROS 2', 'Linux', 'Bash', 'Git',
      'Docker', 'Unity', 'LaTeX', # TODO continue`,
    mobile: `'Python', 'PyTorch', 'Django', 
      'JS/HTML/CSS', 'React', 
      'Tailwind CSS', 'C++', 'CMAKE',
      'ROS 2', 'Linux', 'Bash', 'Git',
      'Docker', 'Unity', 'LaTeX', 
      # TODO continue`,
  }

  const interests = {
    default: `['Deep Learning', 'Robotics', 'Computer Vision']`,
    mobile: `[
      'Deep Learning', 
      'Robotics', 
      'Computer Vision'
    ]`
  }

  const education = {
    default: `'2021': 'B.Sc. Mechanical Engineering at RWTH Aachen'
      '2024': 'M.Sc. Robotics, Cognition, Intelligence at ' \\ 
                   'Technical University of Munich'`,
    mobile: `'2021': 'B.Sc. Mechanical ' \\  
        'Engineering at RWTH Aachen'
      '2024': 'M.Sc. Robotics, ' \\ 
        'Cognition, Intelligence ' \\ 
        'at TU Munich'`,
    }


  let aboutText = `class PhilippWulff(Human):
  ${text(traitsOfCharacter)}

  name = 'Philipp Wulff'
  email = 'philipp.wulff@tum.de'

  def education():
    return {
      ${text(education)}
    }
  
  def interests():
    return ${text(interests)}
  
  def skills():
    return [ 
      ${text(skills)}
    ]

  def run():
    while True:
      self.learn()
`;

  return (
    <ContentSection id="about" sectionTitle={"About"} className={`h-200 mt-20 mb-20`} style={style} maxHeight='1000px'>
      <Code children={aboutText} noCopyButton codeStyle={{paddingLeft: isMobile ? '0px' : '10px', fontSize: isMobile ? '0.9rem' : '1rem'}} className='language-python w-full shadow-3xl rounded-3xl' style={{backgroundColor: '#1e1e1e'}}/>
    </ContentSection>
  )
}

export default AboutSection